import {Component} from 'react';
import './Tooltip.scss';

class Tooltip extends Component {
	constructor(props) {
		super(props);
		this.state = {
			text: '',
			left: 0,
			top: 0,
		}
		this.handleMouseMove = this.handleMouseMove.bind(this);
	}

	handleMouseMove(event) {
		const target = event.target.classList.contains('mark') || event.target.tagName === 'mark'
			? event.target
			: event.target.closest('.mark, mark');

		this.setState({
			text: target && this.props.check ? this.props.check.problemInfo(target) || '' : '',
			left: event.x,
			top: event.y,
		});
	}

	componentDidMount() {
		document.body.addEventListener('mousemove', this.handleMouseMove);
	}

	componentWillUnmount() {
		document.body.removeEventListener('mousemove', this.handleMouseMove);
	}

	render() {
		let style = {
			left: this.state.left + 'px',
			top: this.state.top + 'px',
		};
		return (
			<div className="tooltip" style={style}>{this.state.text}</div>
		)
	}
}

export default Tooltip;